import React, { type CSSProperties, type FormEvent, type RefObject } from "react";

interface FormProps<T = any> {
  children: React.ReactNode;
  onFinish: (formData: T, event: FormData) => void;
  className?: string;
  refObject?: RefObject<HTMLFormElement | null>;
  style?: CSSProperties;
}

const Form = ({
  children,
  onFinish,
  className,
  refObject,
  style,
}: FormProps) => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const formValues: Record<string, any> = {};

    formData.forEach((value, key) => {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (Array.isArray(formValues[key])) {
          formValues[key].push(value);
        } else {
          formValues[key] = [formValues[key], value];
        }
      } else {
        formValues[key] = value;
      }
    });

    onFinish(formValues, formData);
  };

  return (
    <form
      ref={refObject}
      className={className}
      style={style}
      onSubmit={handleSubmit}
    >
      {children}
    </form>
  );
};

export default Form;
